import React, {useContext } from "react";
import { Grid, Typography,Box,Select,Paper,Fab,FormControl,MenuItem,IconButton,OutlinedInput } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import ApplicationContext from "./ApplicationContext";

const useStyles = makeStyles((theme) => ({
	formControl: {
		padding: "0.1rem "
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	gridDesign: {
		paddingLeft: "0.25rem !important",  
	},
	selectField: {
		fontSize:"0.85rem !important",
		padding: "0.7rem .75rem !important",
		textAlign:"left",
		  
	},
	searchField: {
	    fontSize:"0.85rem !important",
		padding: "0.75rem .75rem !important",
	},
	searchButton: {
		marginLeft: "0.5rem",
	},
	fab:{
		fontSize: "0.85rem !important",
		background:"#b6ab22 !important",
		cursor: "default",
		marginLeft: "0.5rem",
		padding: "0.75rem 1.25rem !important",
	  }
}));
export default function AppCardSearch() {
	const classes=useStyles();
    const {totalApp,totalAppsInQueue,handleSearch, handleAppSearchByAPI, handleChangeCriteria,searchCriteria,setSearchInput,searchInput} =useContext(ApplicationContext);
	return (
		<Grid container className={classes.formControl} >
			{/* <Grid item xs={6} >
			   <Box > 
			    <FormControl sx={{ m: 1 }} variant="outlined" fullWidth >
					<Select
						id="outlined-adornment-criteria"
						inputProps={{
							className: classes.selectField,
						}}
						onChange={(event) =>handleChangeCriteria(event.target.value)}
						placeholder="Search Criteria"
						value={searchCriteria }>
						<MenuItem value={"id"}>By Application Id</MenuItem>
						<MenuItem  value={"applicant_name"}>By Applicant</MenuItem>
					</Select>
				</FormControl>
				</Box>
			</Grid> */}
			{/* <Grid item xs={6} >
				<Box  className={classes.gridDesign}> 
				<FormControl sx={{ m: 1 }} variant="outlined" fullWidth>
						<OutlinedInput
						id="outlined-adornment-password"
						inputProps={{
							className: classes.searchField,
						}}
						value={searchInput}
						onChange={handleSearch}
						onKeyPress={(ev) => {
							if (ev.key === "Enter") {
							  ev.preventDefault();
							  handleAppSearchByAPI();
							}
						  }}
						endAdornment={
						<InputAdornment position="end">
						<IconButton
						aria-label="toggle password visibility"
						onClick={handleAppSearchByAPI}
						edge="end"
						>
						<SearchIcon />
						</IconButton>
						</InputAdornment>
						}
						placeholder="Search"
						/>
						</FormControl>
				</Box>
			</Grid> */}
		</Grid>
	);
}
